export default {
    1: { name: "1", url: "numbers/1" },
    2: { name: "2", url: "numbers/2" },
    3: { name: "3", url: "numbers/3" },
    4: { name: "4", url: "numbers/4" },
    5: { name: "5", url: "numbers/5" },
    6: { name: "6", url: "numbers/6" },
    7: { name: "7", url: "numbers/7" },
    8: { name: "8", url: "numbers/8" },
    9: { name: "9", url: "numbers/9" },
    10: { name: "10", url: "numbers/10" },
    11: { name: "11", url: "numbers/11" },
    12: { name: "12", url: "numbers/12" },
    13: { name: "13", url: "numbers/13" },
    14: { name: "14", url: "numbers/14" },
    15: { name: "15", url: "numbers/15" },
    16: { name: "16", url: "numbers/16" },
    17: { name: "17", url: "numbers/17" },
    18: { name: "18", url: "numbers/18" },
    19: { name: "19", url: "numbers/19" },
    20: { name: "20", url: "numbers/20" },
    21: { name: "21", url: "numbers/21" },
    22: { name: "22", url: "numbers/22" },
    23: { name: "23", url: "numbers/23" },
    24: { name: "24", url: "numbers/24" },
    25: { name: "25", url: "numbers/25" },
    26: { name: "26", url: "numbers/26" },
    27: { name: "27", url: "numbers/27" },
    28: { name: "28", url: "numbers/28" },
    29: { name: "29", url: "numbers/29" },
    30: { name: "30", url: "numbers/30" },
    31: { name: "31", url: "numbers/31" },
    32: { name: "32", url: "numbers/32" },
    33: { name: "33", url: "numbers/33" },
    34: { name: "34", url: "numbers/34" },
    35: { name: "35", url: "numbers/35" },
    36: { name: "36", url: "numbers/36" },
    37: { name: "37", url: "numbers/37" },
    38: { name: "38", url: "numbers/38" },
    39: { name: "39", url: "numbers/39" },
    40: { name: "40", url: "numbers/40" },
    41: { name: "41", url: "numbers/41" },
    42: { name: "42", url: "numbers/42" },
    43: { name: "43", url: "numbers/43" },
    44: { name: "44", url: "numbers/44" },
    45: { name: "45", url: "numbers/45" },
    46: { name: "46", url: "numbers/46" },
    47: { name: "47", url: "numbers/47" },
    48: { name: "48", url: "numbers/48" },
    49: { name: "49", url: "numbers/49" },
    50: { name: "50", url: "numbers/50" },
    51: { name: "51", url: "numbers/51" },
    52: { name: "52", url: "numbers/52" },
    53: { name: "53", url: "numbers/53" },
    54: { name: "54", url: "numbers/54" },
    55: { name: "55", url: "numbers/55" },
    56: { name: "56", url: "numbers/56" },
    57: { name: "57", url: "numbers/57" },
    58: { name: "58", url: "numbers/58" },
    59: { name: "59", url: "numbers/59" },
    60: { name: "60", url: "numbers/60" },
    61: { name: "61", url: "numbers/61" },
    62: { name: "62", url: "numbers/62" },
    63: { name: "63", url: "numbers/63" },
    64: { name: "64", url: "numbers/64" },
    65: { name: "65", url: "numbers/65" },
    66: { name: "66", url: "numbers/66" },
    67: { name: "67", url: "numbers/67" },
    68: { name: "68", url: "numbers/68" },
    69: { name: "69", url: "numbers/69" },
    70: { name: "70", url: "numbers/70" },
    71: { name: "71", url: "numbers/71" },
    72: { name: "72", url: "numbers/72" },
    73: { name: "73", url: "numbers/73" },
    74: { name: "74", url: "numbers/74" },
    75: { name: "75", url: "numbers/75" },
    76: { name: "76", url: "numbers/76" },
    77: { name: "77", url: "numbers/77" },
    78: { name: "78", url: "numbers/78" },
    79: { name: "79", url: "numbers/79" },
    80: { name: "80", url: "numbers/80" },
    81: { name: "81", url: "numbers/81" },
    82: { name: "82", url: "numbers/82" },
    83: { name: "83", url: "numbers/83" },
    84: { name: "84", url: "numbers/84" },
    85: { name: "85", url: "numbers/85" },
    86: { name: "86", url: "numbers/86" },
    87: { name: "87", url: "numbers/87" },
    88: { name: "88", url: "numbers/88" },
    89: { name: "89", url: "numbers/89" },
    90: { name: "90", url: "numbers/90" },
    91: { name: "91", url: "numbers/91" },
    92: { name: "92", url: "numbers/92" },
    93: { name: "93", url: "numbers/93" },
    94: { name: "94", url: "numbers/94" },
    95: { name: "95", url: "numbers/95" },
    96: { name: "96", url: "numbers/96" },
    97: { name: "97", url: "numbers/97" },
    98: { name: "98", url: "numbers/98" },
    99: { name: "99", url: "numbers/99" },
}
